<div class="page">
  <div class="card">
    <div class="card-header">
      <div>
        <app-page-site-switcher [variant]="'header'"></app-page-site-switcher>
        <h1>{{ 'actualite.journal.header.title' | translate }}</h1>
        <p class="subtitle">{{ 'actualite.journal.header.subtitle' | translate }}</p>
      </div>
      <div class="filtres">
        <div class="filtre-group">
          <label>{{ 'actualite.journal.filters.label' | translate }}</label>
          <select [(ngModel)]="filtreType" (change)="onFilterChange()" class="select-filtre">
            <option value="Tous">{{ 'actualite.journal.filters.all' | translate }}</option>
            <option value="Humain">{{ 'actualite.journal.filters.team' | translate }}</option>
            <option value="IA">{{ 'actualite.journal.filters.assistant' | translate }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="page-layout">
      <!-- Colonne composeur -->
      <div class="composer-column">
        <div class="nouveau-message">
          <div class="composer-header">
            <h3>{{ 'actualite.journal.composer.title' | translate }}</h3>
            <button class="btn-toggle-composer" (click)="toggleComposer()">
              <span>{{ showComposer() ? '−' : '+' }}</span>
              <span>{{ (showComposer() ? 'actualite.journal.composer.toggleHide' : 'actualite.journal.composer.toggleShow') | translate }}</span>
            </button>
          </div>
          <div *ngIf="showComposer()" class="composer-content">
          <div class="form-group">
            <input
              type="text"
              [(ngModel)]="nouveauTitre"
              [placeholder]="'actualite.journal.composer.titlePlaceholder' | translate"
              class="input-titre"
              maxlength="100">
          </div>
          <div class="form-group">
            <select [(ngModel)]="selectedTemplate" (change)="onTemplateSelect()" class="input-titre">
              <option value="">{{ 'actualite.journal.composer.templatePlaceholder' | translate }}</option>
              <option *ngFor="let template of newsTemplates()" [value]="template.id">{{ template.name }}</option>
            </select>
          </div>

          <div class="form-group">
            <div class="textarea-container">
              <textarea
                #messageTextarea
                [value]="nouveauMessage"
                (input)="onTextareaInput($event)"
                [placeholder]="'actualite.journal.composer.messagePlaceholder' | translate"
                class="textarea-message"
                maxlength="300"
                rows="6"></textarea>
              <button type="button" class="btn-emoji" (click)="showEmojiPicker = !showEmojiPicker">😊</button>

              <!-- Dropdown mentions -->
              <div *ngIf="showMentionDropdown" class="mention-dropdown">
                <div
                  *ngFor="let user of filteredUsers"
                  class="mention-item"
                  (click)="selectMention(user, messageTextarea)">
                  {{ user.name }}
                </div>
              </div>

              <!-- Emoji Picker -->
              <emoji-mart *ngIf="showEmojiPicker"
                          class="emoji-picker"
                          (emojiSelect)="addEmoji($event)"
                          [darkMode]="false">
              </emoji-mart>
            </div>
            <div class="char-count">{{ nouveauMessage.length }}/300</div>
          </div>
          <button
            class="btn-publier"
            (click)="publierMessage()"
            [disabled]="!nouveauTitre.trim() || !nouveauMessage.trim()">
            {{ 'actualite.journal.composer.publish' | translate }}
          </button>
          </div>
        </div>


      </div>

      <!-- Colonne messages -->
      <div class="messages-column">

        <!-- Loading/Error states -->
        <div class="state" *ngIf="loading()">{{ 'actualite.journal.states.loading' | translate }}</div>
        <div class="state error" *ngIf="!loading() && error()">{{ error() }}</div>

    <!-- Messages -->
    <div *ngIf="!loading() && !error() && data() as response" class="messages-container">
      <div class="messages-list">
        <div *ngFor="let message of response.content" class="message-item" [class.ia-message]="message.type === 'IA'">
        <div class="message-header">
          <div class="header-ligne-1">
            <span *ngIf="isRecent(message.timestamp)" class="badge-nouveau">{{ 'actualite.journal.message.new' | translate }}</span>
          </div>
          <div class="header-ligne-1">
            <h4 class="message-titre" [class.ia-titre]="message.type === 'IA'">{{ message.titre }}</h4>
          </div>
          <div class="header-ligne-2">
            <img *ngIf="message.type === 'IA'" src="assets/IconORA.svg" alt="" class="ia-icon" />
            <span class="auteur-nom" [class.ia]="message.type === 'IA'">
              {{ message.auteur }}
            </span>
            <span class="separator">·</span>
            <span class="message-time">{{ getTimeAgo(message.timestamp) }}</span>
            <button
              *ngIf="message.canDelete || message.type === 'IA'"
              class="btn-supprimer-header"
              (click)="supprimerMessage(message.id)"
              [title]="'actualite.journal.message.deleteTitle' | translate">
              <img src="assets/delete.svg" [attr.alt]="'actualite.journal.message.deleteAlt' | translate" class="icon-delete" />
            </button>
            <button
              *ngIf="message.canEdit"
              class="btn-modifier-header"
              (click)="startEditMessage(message)"
              [title]="'actualite.journal.message.editTitle' | translate">
              <img src="assets/modification.svg" [attr.alt]="'actualite.journal.message.editAlt' | translate" class="icon-edit" />
            </button>
          </div>
        </div>

        <div class="message-content">
          <div *ngIf="editingMessageId() === message.id; else displayMessage" class="edit-form">
            <input type="text" [(ngModel)]="editTitre" class="edit-titre" [placeholder]="'actualite.journal.message.editPlaceholderTitle' | translate" />
            <textarea [(ngModel)]="editContenu" class="edit-contenu" rows="4"></textarea>
            <div class="edit-actions">
              <button class="btn-cancel-edit" (click)="cancelEditMessage()">{{ 'actualite.journal.message.cancel' | translate }}</button>
              <button class="btn-save-edit" (click)="saveEditMessage(message.id)">{{ 'actualite.journal.message.save' | translate }}</button>
            </div>
          </div>
          <ng-template #displayMessage>
            <p class="message-texte">
              <span *ngIf="!isLongMessage(message.contenu) || expandedMessages()[message.id]; else truncated">
                <ng-container *ngFor="let part of splitMentions(message.contenu)">
                  <span *ngIf="!part.isMention">{{ part.text }}</span>
                  <span *ngIf="part.isMention" class="mention">{{ part.text }}</span>
                </ng-container>
              </span>
              <ng-template #truncated>
                <ng-container *ngFor="let part of splitMentions(getTruncatedContent(message.contenu))">
                  <span *ngIf="!part.isMention">{{ part.text }}</span>
                  <span *ngIf="part.isMention" class="mention">{{ part.text }}</span>
                </ng-container>
                <button class="btn-voir-plus" (click)="toggleExpanded(message.id)">{{ 'actualite.journal.message.seeMore' | translate }}</button>
              </ng-template>
            </p>
            <button *ngIf="isLongMessage(message.contenu) && expandedMessages()[message.id]"
                    class="btn-voir-moins"
                    (click)="toggleExpanded(message.id)">
              {{ 'actualite.journal.message.seeLess' | translate }}
            </button>
          </ng-template>
        </div>

        <div class="message-actions">
          <button
            class="btn-commentaires"
            (click)="toggleComments(message.id)">
            {{ 'actualite.journal.message.commentCount' | translate: { count: message.commentaires?.length || 0 } }}
          </button>
        </div>

        <!-- Commentaires -->
        <div *ngIf="showComments()[message.id]" class="commentaires-section">
          <div class="commentaires-separator"></div>
          <div *ngFor="let commentaire of message.commentaires || []" class="commentaire-item">
            <div class="commentaire-layout">
              <div class="commentaire-avatar">{{ getInitials(commentaire.auteur) }}</div>
              <div class="commentaire-content">
                <div class="commentaire-header">
                  <span class="commentaire-auteur">{{ commentaire.auteur }}</span>
                  <span class="separator">·</span>
                  <span class="commentaire-time">{{ getTimeAgo(commentaire.timestamp) }}</span>
                  <button
                    *ngIf="commentaire.canDelete"
                    class="btn-supprimer-commentaire"
                    (click)="supprimerCommentaire(commentaire.id)"
                    [title]="'actualite.journal.comment.deleteTitle' | translate">
                    <img src="assets/delete.svg" [attr.alt]="'actualite.journal.message.deleteAlt' | translate" class="icon-delete-small" />
                  </button>
                  <button
                    *ngIf="commentaire.canEdit"
                    class="btn-modifier-commentaire"
                    (click)="startEditCommentaire(commentaire)"
                    [title]="'actualite.journal.comment.editTitle' | translate">
                    <img src="assets/modification.svg" [attr.alt]="'actualite.journal.message.editAlt' | translate" class="icon-edit-small" />
                  </button>
                </div>
                <div *ngIf="editingCommentaireId() === commentaire.id; else displayCommentaire" class="edit-form-commentaire">
                  <textarea [(ngModel)]="editContenu" class="edit-contenu-commentaire" rows="2"></textarea>
                  <div class="edit-actions-commentaire">
                    <button class="btn-cancel-edit" (click)="cancelEditCommentaire()">{{ 'actualite.journal.message.cancel' | translate }}</button>
                    <button class="btn-save-edit" (click)="saveEditCommentaire(commentaire.id)">{{ 'actualite.journal.message.save' | translate }}</button>
                  </div>
                </div>
                <ng-template #displayCommentaire>
                  <p class="commentaire-texte">
                    <ng-container *ngFor="let part of splitMentions(commentaire.contenu)">
                      <span *ngIf="!part.isMention">{{ part.text }}</span>
                      <span *ngIf="part.isMention" class="mention">{{ part.text }}</span>
                    </ng-container>
                  </p>
                </ng-template>
              </div>
            </div>
          </div>

          <!-- Nouveau commentaire -->
          <div class="nouveau-commentaire">
            <div class="textarea-container">
              <textarea
                #commentTextarea
                [value]="nouveauCommentaire()[message.id] || ''"
                (input)="onCommentInput($event, message.id)"
                [placeholder]="'actualite.journal.comment.placeholder' | translate"
                class="textarea-commentaire"
                rows="2"></textarea>
              <button type="button" class="btn-emoji-comment" (click)="toggleCommentEmojiPicker(message.id)">😊</button>

              <!-- Dropdown mentions pour commentaires -->
              <div *ngIf="showCommentMentionDropdown()[message.id]" class="mention-dropdown">
                <div
                  *ngFor="let user of filteredUsers"
                  class="mention-item"
                  (click)="selectCommentMention(user, commentTextarea, message.id)">
                  {{ user.name }}
                </div>
              </div>

              <!-- Emoji Picker pour commentaires -->
              <emoji-mart *ngIf="showCommentEmojiPicker()[message.id]"
                          class="emoji-picker"
                          (emojiSelect)="addCommentEmoji($event, message.id)"
                          [darkMode]="false">
              </emoji-mart>
            </div>
            <button
              class="btn-commenter"
              (click)="ajouterCommentaire(message.id)"
              [disabled]="!nouveauCommentaire()[message.id]?.trim()">
              {{ 'actualite.journal.comment.submit' | translate }}
            </button>
          </div>
        </div>
      </div>

      <!-- Pagination -->
      <div class="pagination" *ngIf="response.totalPages > 1">
        <button
          class="btn-page"
          [disabled]="response.number === 0"
          (click)="previousPage()">
          {{ 'actualite.journal.pagination.previous' | translate }}
        </button>

        <span class="page-info">
          {{ 'actualite.journal.pagination.info' | translate: { current: response.number + 1, total: response.totalPages } }}
        </span>

        <button
          class="btn-page"
          [disabled]="response.number >= response.totalPages - 1"
          (click)="nextPage()">
          {{ 'actualite.journal.pagination.next' | translate }}
        </button>
      </div>
    </div>

        <div class="state" *ngIf="!loading() && !error() && !data()">{{ 'actualite.journal.states.empty' | translate }}</div>
      </div>
    </div>
  </div>
</div>

<app-confirm-modal
  *ngIf="showConfirmModal()"
  [title]="confirmModalTitle()"
  [message]="confirmModalMessage()"
  [confirmText]="'actualite.journal.confirm.confirmText' | translate"
  [cancelText]="'actualite.journal.confirm.cancelText' | translate"
  (confirm)="onConfirmAction()"
  (cancel)="onCancelAction()">
</app-confirm-modal>
